/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function() {
  const selector = '.ux-pdp #klaviyo-bis-button-container button';
  const classes = ['btn', 'ux-button', 'ux-button--primary', 'btn--large', 'btn--solid', 'btn--primary'];

  const decorate = () => {
    document.querySelectorAll(selector).forEach((button) => {
      button.classList.add(...classes);
    });
  };

  const product = document.querySelector('.ux-pdp');

  if (!product) return;

  decorate();

  const observer = new MutationObserver(decorate);
  observer.observe(product, { childList: true, subtree: true });
})();
